module.exports = require('../dist/components/Link/Link');
